// src/modules/app-views/invoices/pages/Init/modals/ExportXmlModal/Step1.jsx
// *******************************************************************************
// EXPORT XML STEP - Month and Document Type Selection
// *******************************************************************************
// Allows user to select month and document type (NFe/NFCe/Both) for XML export.
// *******************************************************************************

// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Segmented, Typography } from 'antd';
import SimpleDatePicker from 'components/SimpleComponents/SimpleDatePicker';
import { useSimpleFormContext } from 'components/SimpleComponents/SimpleFormProvider';
import translateX from 'utils/translateX';

const { Text } = Typography;

// *******************************************************************************
// STEP CONTENT COMPONENT
// *******************************************************************************
const ExportXmlStepContent = ({ company }) => {
  const { form } = useSimpleFormContext();

  const handleDocumentTypeChange = value => {
    form.setFieldsValue({ documentType: value });
  };

  // Get issuer info for display
  const companyName = company?.name || company?.fullName || company?.razaoSocial;
  const companyCnpj = company?.cnpj?.value || company?.documento?.cnpj?.value;

  return (
    <div className="export-xml-modal-content" style={{ paddingTop: 8 }}>
      {/* Company info */}
      {companyName && (
        <div style={{ marginBottom: 16 }}>
          <Text type="secondary">{translateX('issuer')}: </Text>
          <Text strong>{companyName}</Text>
          {companyCnpj && (
            <Text type="secondary" style={{ marginLeft: 8 }}>
              ({companyCnpj})
            </Text>
          )}
        </div>
      )}

      <SimpleDatePicker
        name="month"
        label={translateX('select_month')}
        picker="month"
        format="MM/YYYY"
        required
        style={{ width: '100%' }}
      />
      <div style={{ marginTop: 16 }}>
        <h5 style={{ marginBottom: 8 }}>{translateX('export_type')}</h5>
        <Segmented
          block
          defaultValue="all"
          options={[
            { label: 'NFe', value: 'nfe' },
            { label: 'NFCe', value: 'nfce' },
            { label: translateX('all'), value: 'all' },
          ]}
          onChange={handleDocumentTypeChange}
        />
      </div>
    </div>
  );
};

// *******************************************************************************
// STEP CONFIGURATION FACTORY
// *******************************************************************************
const createExportXmlStep = ({ company } = {}) => ({
  stepTitle: 'export_xml',
  content: () => <ExportXmlStepContent company={company} />,
  validationFields: ['month'],
});

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default createExportXmlStep;
